/**
 * Created by roman.kupin on 10/3/2017.
 */

import * as GuestsJourneysActions from "../actions/index";
import * as PrestayApiActions from "../../../../../actions/api/prestayApi";
import * as PoststayApiActions from "../../../../../actions/api/poststayApi";
import * as PhotoAdvocacyApiActions from "../../../../../actions/api/photoAdvocacyApi";
import Parse from "../../../../../utils/parse";


export default function guestsJourneysReducer(state = {
    isInitialized: false,
    prestayCampaignsSortMode: false,
    poststayCampaignsSortMode: false
}, {type, payload}) {

    switch (type) {
        case GuestsJourneysActions.INITIALIZED: {
            return Object.assign({}, state, {isInitialized: payload});
        }
        case PrestayApiActions.CAMPAIGNS_FETCH_SUCCESS: {
            if(!payload) {
                return Object.assign({}, state);
            }
            const defaultCampaign = Parse.arrayOrDefault(payload.campaigns).find(campaign => campaign.type == 255);
            const defaultCampaignShareIncentive = Parse.arrayOrDefault(defaultCampaign.goals).find(goal => goal.type == 1);
            const defaultCampaignSignupIncentive = Parse.arrayOrDefault(defaultCampaign.goals).find(goal => goal.type == 2);
            return Object.assign({}, state, {
                prestayShareIncentive: defaultCampaignShareIncentive,
                prestaySignupIncentive: defaultCampaignSignupIncentive
            });
        }
        case PoststayApiActions.CAMPAIGNS_FETCH_SUCCESS: {
            if(!payload) {
                return Object.assign({}, state);
            }
            const defaultCampaign = Parse.arrayOrDefault(payload.campaigns).find(campaign => campaign.type == 255);
            const defaultCampaignShareIncentive = Parse.arrayOrDefault(defaultCampaign.goals).find(goal => goal.type == 4);
            return Object.assign({}, state, {
                poststayShareIncentive: defaultCampaignShareIncentive
            });
        }
        case PhotoAdvocacyApiActions.CAMPAIGNS_FETCH_SUCCESS: {
            if(!payload) {
                return Object.assign({}, state);
            }
            const defaultCampaign = Parse.arrayOrDefault(payload.campaigns).find(campaign => campaign.type == 255);
            const defaultCampaignSignupIncentive = Parse.arrayOrDefault(defaultCampaign.goals).find(goal => goal.type == 2);
            return Object.assign({}, state, {
                photoAdvocacySignupIncentive: defaultCampaignSignupIncentive
            });
        }
        default: {
            return state;
        }
    }
}